/* eslint-disable no-useless-escape */
/* eslint-disable import/prefer-default-export */
export const expresiones = {
  alphanumeric: /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s\.\,\;\:\-\_\!\¡\?\¿\'\"\%\$\@\#\(\)\&]*$/,
  address: /^[a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\s#-]*$/,
  phone: /^[0-9]{7,10}$/,
  numeric: /^[0-9]*$/,
  alphabetical: /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/,
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
